import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

import { Checkout } from "@/features/my/checkout";

export const Route = createFileRoute("/(member)/(protected)/my/checkout/")({
  component: Checkout,
  validateSearch: z.object({
    purchaseIntentId: z.string().optional(),
    planKey: z.string().optional(),
    discountCode: z.string().optional(),
    referId: z.string().optional(),
    referredBy: z.string().optional(),
  }),
});
